/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import orderClient from '../../apis/checkout-apis/orderClient';
import { getAccessTokenSafely } from '../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';

export const getCityStateFromZip = async (zipCode) => {
    let hasErrorMessage = false;
    const jwtToken = await getAccessTokenSafely();
    await orderClient.getCityStateFromZip({}, jwtToken, zipCode).then((response) => {
        const esbSaltaServiceResponse = response?.data?.esbSaltaServiceResponse;
        const location = esbSaltaServiceResponse.checkZipResponse?.checkZipResult?.location;
        if (location) {
            if (!(location?.country === 'USA' || location?.country === 'US')) {
                hasErrorMessage = true;

            }
        }
        else if (esbSaltaServiceResponse.checkZipResponse?.checkZipResult?.flwsErrors?.flwsError?.errorMessage) {
            hasErrorMessage = true
        }

    });

    return hasErrorMessage;

}